import { Box, Link, Paper, Stack, Typography } from "@mui/material";

export default function AboutMe() {
  const information = [
    `Hi, I’m Riley (he/him), based in Ho Chi Minh City, Vietnam.`,
    `This website showcases my work and experience as a software engineer, with a strong focus on full-stack and crypto-related systems.`,
    `I’m a Senior Full-Stack Developer with over 7 years of professional experience, currently working at SPLabs.`,
    `In my day-to-day work, I primarily use TypeScript and JavaScript, building scalable systems with Node.js, React, Next.js, and production-ready backend services using MySQL, Redis, and Docker.`,
    `I have extensive experience working on crypto platforms, including social networks, MLM systems, trading bots, games, and token sale ecosystems. I also build cross-platform mobile applications with React Native.`,
    ` `,
    `A brief summary of my work:`,
    ` ▪ 7+ years of professional software development experience`,
    ` ▪ Full-stack development for crypto, fintech, and web platforms`,
    ` ▪ Experience leading frontend tasks and collaborating across teams`,
    ` ▪ Strong background in system design, backend services, and scalable architectures`,
    ` `,
    `All opinions are my own.`,
  ];

  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Stack direction={"row"} spacing={4} mb={2}>
        <Box width={30}>
          {new Array(16).fill(0).map((_, index) => (
            <Typography
              key={index}
              align="right"
              fontWeight={600}
              color="text.secondary"
            >
              {index + 1}
            </Typography>
          ))}
        </Box>
        <Box width={"calc(100% - 30px)"}>
          {information.map((line, index) => (
            <Typography
              key={index}
              fontFamily={"Source Code Pro, monospace"}
              sx={{
                whiteSpace: "pre-wrap",
              }}
            >
              {line}
            </Typography>
          ))}
        </Box>
      </Stack>
      <Link
        href="/CV_Riley_Tran_Minh_Tam.pdf"
        target="_blank"
        rel="noopener"
        underline="none"
        download
      >
        Download CV
      </Link>
    </Paper>
  );
}
